export default {
  KNOWLEDGE_PORTAL: 'KnowledgePortalUser',
  HR: 'HRUser',
  BUSINESS: 'BusinessUser',
  ADMIN: 'AdminUser',
  MI: 'MIUser',
}
